const namespaced = true;

const defaultState = () => {
  return {
    visibleColumns: [
      {
        name: "SELECT",
        val: "selection",
      },
      {
        name: "Graph",
        val: "graph",
      },
      {
         name: "Company",
         val: "company",
      },
      {
        name: "Location",
        val: "location",
      },
      {
        name: "Unit",
        val: "unit",
      },
      {
        name: "Vehicle Class",
        val: "class_name",
      },
      {
        name: "VIN",
        val: "vin",
      },
      {
        name: "Model Year",
        val: "model_year",
      },
      {
        name: "Make",
        val: "brand",
      },
      {
        name: "Model",
        val: "model",
      },
      {
        name: "In Service Date",
        val: "in_service_date",
      },
      {
        name: 'Months in Service',
        val: 'months_in_service'
      },
      // {
      //   name: "Model Detail",
      //   val: "model_detail",
      // },
      {
        name: "Mileage",
        val: "mileage",
      },
      {
        name: 'AVG CR',
        val: 'condition_grade'
      },
      {
        name: "Condition",
        val: "condition",
      },
      {
        name: "Condition",
        val: "condition",
      },
      {
        name: "Manheim Auction Value",
        val: "mmr",
      },
      {
        name: "Blackbook Auction Value",
        val: "blackbook_auction",
      },
      {
        name: "Manheim Auction Weekly Change",
        val: "auction_weekly_change",
      },
      {
        name: "Estimated Payoff",
        val: "payoff",
      },
      {
        name: "Estimated Revenue/Loss",
        val: "revenue",
      },
      {
        name: "Estimated Cap Cost",
        val: "estimated_cap_cost",
      },
      {
        name: "Initial Purchase Price",
        val: "purchase_amount",
      },
      {
        name: "Monthly Payment",
        val: "monthly_payment",
      },
      {
        name: "Remaning Months",
        val: "aging",
      },
      {
        name: "Color",
        val: "color",
      },
      {
        name: "Finance",
        val: "source",
        sub: "Finance",
      },
      {
        name: "Custom Tag",
        val: "tags",
      },
      {
        name: "Status",
        val: "status",
      },
    ],
    companies: [],
    locations: [],
    companyFilter: "",
    selectedLocations: [],
    advancedFilters: {
      sources: [],
      groups: [],
      classes: [],
      brands: [],
      model_years: [],
      sign: [
        { name: "Estimated Revenue", value: "positive" },
        { name: "Estimated Loss", value: "negative" },
      ],
      positive: [
        {
          name: "1-500",
          val: "1-500",
        },
        {
          name: "500-1000",
          val: "500-1000",
        },
        {
          name: "1000-1500",
          val: "1000-1500",
        },
        {
          name: "1500-2000",
          val: "1500-2000",
        },
        {
          name: "2000 and Higher",
          val: "2000-",
        },
      ],
      negative: [
        {
          name: "-500/1",
          val: "-500,1",
        },
        {
          name: "-1000/-500",
          val: "-1000,-500",
        },
        {
          name: "-1500/-1000",
          val: "-1500,-1000",
        },
        {
          name: "-2000/-1500",
          val: "-2000,-1500",
        },
        {
          name: "-2000 and Lower",
          val: "-2000",
        },
      ],
      providers: [],
    },
    conditions: [
      {
        name: "Condition by Car",
        val: "default",
      },
      {
        name: "Above",
        val: "excellent",
      },
      {
        name: "Average",
        val: "good",
      },
      {
        name: "Below",
        val: "fair",
      },
    ],
    conditionFilters: [
      {
        name: "Above",
        val: "excellent",
      },
      {
        name: "Average",
        val: "good",
      },
      {
        name: "Below",
        val: "fair",
      },
    ],
    conditionChooser: {
      name: "Condition by Car",
      val: "default",
    },
    exportEx: {
      show: false,
      params: {},
    },
    vehicles: [],
    multiFilter: [],
    statusFilter: [],
    loading: false,
    source: [],
    group: [],
    class: [],
    brandId: [],
    modelYear: [],
    modelId: [],
    sign: "",
    min: "",
    range: "",
    max: "",
    activate: false,
    mmr: "",
    mileage: "",
    payOff: "",
    revenue: "",
    monthlyPayment: "",
    avgRevenue: "",
    avgMileage: "",
    total: "",
    search: "",
    negRev: "",
    posRev: "",
    service_date: "",
    tagging: false,
    selectedTags: [],
    conditionChooserFilter: [],
    financial: true,
    manuallyPriced: null,
    provider: { name: "Manheim", key: "manheim" },
    refreshRequired: false,
    defaultMarketValueUpdated: null,
    previewCondition: null,
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  SET_PROVIDER(state, provider) {
    state.provider = provider;
  },
  SET_FINANCIAL(state, financial) {
    state.financial = financial;
  },
  SET_MANUALLY_PRICED(state, manuallyPriced) {
    state.manuallyPriced = manuallyPriced;
  },
  SET_VEHICLES_TAGS_CHANGED(state, vehicles) {
    for (let i = 0; i < state.vehicles.length; i++) {
      for (let j = 0; j < vehicles.length; j++) {
        state.vehicles[i].id === vehicles[j].vehicle
          ? (state.vehicles[i].tags = vehicles[j].tags)
          : "";
      }
    }
    state.selectedVehicles = [];
  },
  REMOVE_TAG_EXISTING_VEHICLE(state, tag_id) {
    for (let i = 0; i < state.vehicles.length; i++) {
      const tags = [...state.vehicles[i].tags];
      for (let j = 0; j < tags.length; j++) {
        if (tags[j].id === tag_id) tags.splice(j, 1);
      }
      state.vehicles[i].tags = tags;
    }
  },
  SET_TAG_CONDITION(state, selectedTags) {
    state.selectedTags = selectedTags;
  },
  SET_FILTER_CONDITION(state, conditionChooserFilter) {
    state.conditionChooserFilter = conditionChooserFilter;
  },
  SET_CONDITION_SETTER(state, conditionChooser) {
    state.conditionChooser = conditionChooser;
  },
  SET_TAG_OPERATION(state, tagging) {
    state.tagging = tagging;
  },
  resetState(state) {
    Object.assign(state, defaultState());
  },
  UPDATE_VEHICLE_CONDITION(state, vehicle) {
    const index = state.vehicles.findIndex((item) => item.vin === vehicle.vin);
    index !== -1 ? state.vehicles.splice(index, 1, vehicle) : "";
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  CHECK_EDIT_LOCATION(state, location) {
    const index = state.locations.map((item) => item.id).indexOf(location.id);
    index !== -1 ? state.locations.splice(index, 1, location) : "";

    const multiIndex = state.multiFilter
      .map((item) => item.id)
      .indexOf(location.id);
    multiIndex !== -1 ? state.multiFilter.splice(multiIndex, 1, location) : "";
  },
  REM_LOCATION_TO_SELECTED_LOCATION(state, id) {
    const index = state.locations.map((item) => item.id).indexOf(id);
    index !== -1 ? state.locations.splice(index, 1) : "";

    const multiIndex = state.multiFilter.map((item) => item.id).indexOf(id);
    multiIndex !== -1 ? state.multiFilter.splice(multiIndex, 1) : "";
  },
  DELETE_SELECTED_VEHICLE(state, id) {
    state.companyFilter.id === id ? (state.companyFilter = {}) : "";
    state.multiFilter = [];
  },
  ADD_LOCATION_TO_SELECTED_LOCATION(state, newVal) {
    const index = state.locations.map((item) => item.id).indexOf(newVal.id);
    index === -1 ? (state.locations = [...state.locations, newVal]) : "";
  },
  SET_CHECK_EDIT_COMPANY(state, companyFilter) {
    state.companyFilter.id === companyFilter.id
      ? (state.companyFilter = companyFilter)
      : "";
  },
  SET_VISIBLE_COLUMNS(state, visibleColumns) {
    state.visibleColumns = visibleColumns;
  },
  SET_EXPORT(state, exportEx) {
    state.exportEx = exportEx;
  },
  SET_TOTAL(state, total) {
    state.total = total;
  },
  SET_PAY_OFF(state, payOff) {
    state.payOff = payOff;
  },
  SET_MMR(state, mmr) {
    state.mmr = mmr;
  },
  SET_NEG_REV(state, negRev) {
    state.negRev = negRev;
  },
  SET_POS_REV(state, posRev) {
    state.posRev = posRev;
  },
  SET_MILEAGE(state, mileage) {
    state.mileage = mileage;
  },
  SET_AVG_MILEAGE(state, avgMileage) {
    state.avgMileage = avgMileage;
  },
  SET_AVG_REVENUE(state, avgRevenue) {
    state.avgRevenue = avgRevenue;
  },
  SET_REVENUE(state, revenue) {
    state.revenue = revenue;
  },
  SET_MONTHLY_PAYMENT(state, monthlyPayment) {
    state.monthlyPayment = monthlyPayment;
  },
  SET_RANGE_VAL(state, val) {
    state.range = val;
  },
  SET_SOURCES(state, val) {
    state.source = val;
  },
  SET_GROUPS(state, val) {
    state.group = val;
  },
  SET_CLASSES(state, val) {
    state.class = val;
  },
  SET_MODEL_YEARS(state, val) {
    state.modelYear = val;
  },
  SET_SIGN(state, val) {
    state.sign = val;
  },
  SET_MIN(state, val) {
    state.min = val;
  },
  SET_MAX(state, val) {
    state.max = val;
  },
  SET_MODELS_ID(state, val) {
    state.modelId = val;
  },
  SET_BRANDS_ID(state, val) {
    state.brandId = val;
  },
  SET_ACTIVATE_MODAL(state, activate) {
    state.activate = activate;
  },
  SET_CHOOSEN_FILTERS(state, choosenFilters) {
    state.choosenFilters = choosenFilters;
  },
  SET_MULTI_FILTER(state, multiFilter) {
    state.multiFilter = multiFilter;
  },
  SET_ADVANCED_FILTER(state, advancedFilters) {
    state.advancedFilters = advancedFilters;
  },
  REMOVE_MULTI_FILTER(state, index) {
    state.multiFilter.splice(index, 1);
  },
  SET_STATUS_FILTER(state, statusFilter) {
    state.statusFilter = statusFilter;
  },
  REMOVE_STATUS_FILTER(state, index) {
    state.statusFilter.splice(index, 1);
  },
  SET_VEHICLES(state, vehicles) {
    state.vehicles = vehicles;
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies;
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations;
  },
  SET_COMPANY(state, company) {
    state.company = company;
  },
  SET_REFRESH_REQUIRED(state, value) {
    state.refreshRequired = value;
  },
  SET_DEFAULT_MARKET_VALUE_UPDATED(state, value) {
    state.defaultMarketValueUpdated = value;
  },
  SET_PREVIEW_CONDITION(state, value) {
    state.previewCondition = value;
  },
  // SET_SERVICE_DATE(state, val) {
  //   state.service_date = val && val.split(" ")[0];
  // },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
